import { render, staticRenderFns } from "./LiveCourses.vue?vue&type=template&id=c476bf1a"
import script from "./LiveCourses.vue?vue&type=script&lang=ts"
export * from "./LiveCourses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports